import domReady from '@wordpress/dom-ready';
import manifest from './../manifest.json';
import navbarVideoManifest from './../../../components/navbar-video/manifest.json';

domReady(async () => {
	const { blockJsClass, blockJsLeftClass, blockJsItemClass, blockJsItemLinkClass, blockJsItemSubitemsClass } = manifest;

	const navbarSelector = `.${blockJsClass}`;
	const navbarFlyoutSelector = `${navbarSelector}-flyout`;
	const navbarElem = document.querySelector(navbarSelector);
	const navbarFlyoutElem = document.querySelector(navbarFlyoutSelector);

	if (!navbarElem && !navbarFlyoutElem) {
		return;
	}

	if (navbarElem) {
		const { Navbar } = await import('./navbar');
		const navbar = new Navbar({
			selector: navbarSelector,
			subitemsSelector: `.${blockJsItemSubitemsClass}`,
			itemSelector: `.${blockJsItemClass}`,
			navbarLeftSelector: `.${blockJsLeftClass}`,
			itemLinkSelector: `.${blockJsItemLinkClass}`,
			videoSelector: `.${navbarVideoManifest.componentJsClass}`,
			elem: navbarElem,
		});

		navbar.init();
	}

	if (navbarFlyoutElem) {
		const { NavbarFlyout } = await import('./navbar-flyout');
		const navbarFlyout = new NavbarFlyout({
			selector: navbarFlyoutSelector,
			elem: navbarFlyoutElem,
		});

		navbarFlyout.init();
	}
});
